// CevapQcIstek — kartta "QC'ye gönder" (2026-09-15, kullanıcı isteği "panele QC'ye gönder
// düğmesini ekle").
//
// İstek sıraya yazılır (denetim_izi, kural CEVAP-QC-ISTEK). Sunucudaki rtn-bakim-cevap-qc
// routine'i AÇIKSA "şimdi çalıştır" niyetiyle birkaç dakika içinde işler ve sonuç bu karta
// düşer; KAPALIYSA istek sırada bekler, Claude oturumunda "/cevap-dogrulama-qc istek" ile
// işlenir. Yalnız admin'e çizilir (App `onIstek`i yalnız admin'e verir — her istek token
// harcar); kapsam dışı derste ve kör modda (SoruKarti) çizilmez.
import React, { useState } from 'react';

const zaman = (t) => {
  if (!t) return '';
  const d = new Date(t);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('tr-TR');
};

export default function CevapQcIstek({ soru, onIstek }) {
  const [istek, setIstek] = useState((soru && soru.cevap_qc_istek) || null);
  const [mesaj, setMesaj] = useState('');
  const [hata, setHata] = useState('');
  const [bekle, setBekle] = useState(false);
  if (!soru || !onIstek || !soru.cevap_qc_istek_kapsam) return null;

  const aktif = !!istek && (istek.durum === 'BEKLIYOR' || istek.durum === 'ISLENIYOR');

  const gonder = async (iptal) => {
    if (bekle) return;
    setBekle(true);
    setHata('');
    setMesaj('');
    try {
      const d = await onIstek(soru, { iptal });
      if (iptal) {
        setIstek(null);
        setMesaj(d && d.iptal ? 'QC isteği iptal edildi.' : 'İstek artık iptal edilemiyor (işleniyor olabilir).');
        return;
      }
      setIstek((d && d.istek) || null);
      const r = (d && d.rutin) || {};
      if (r.acik) {
        // QC şeridi (2026-09-22) sırayı dakikada bir doğrudan okur ve üretim kuyruğundan
        // bağımsız kendi yuvasında koşar. Şeridi durduran TEK şey iki hesabın da limitli
        // olması — o hâlde söz vermek yerine açılış saatini söyle (eski metin "birkaç
        // dakika" diyordu, ölçülen bekleme 2,7 saatti ve kullanıcı sessizlikte kaldı).
        const h = r.hesap || {};
        if (h.musait === false) {
          setMesaj('QC sırasına alındı ama her iki Claude hesabının da limiti dolu — '
            + `şerit açılışta (${zaman(h.acilis) || 'reset sonrası'}) otomatik başlar.`);
        } else {
          setMesaj(d.mevcut
            ? 'Zaten sırada — QC şeridi yeniden tetiklendi.'
            : 'QC sırasına alındı — şerit ≤1 dakika içinde başlatır (üretim kuyruğunu '
              + 'beklemez). Sonuç bu karta düşer.');
        }
      } else {
        setMesaj('QC sırasına alındı. Otomatik işleme (rtn-bakim-cevap-qc) şu an KAPALI — istek, '
          + 'Claude oturumunda “/cevap-dogrulama-qc istek” ile işlenir.');
      }
    } catch (e) {
      setHata((e && e.message) || String(e));
    } finally {
      setBekle(false);
    }
  };

  return (
    <div data-cevap-qc-istek className="mt-3 flex flex-wrap items-center gap-2 text-[13px]">
      {!aktif && (
        <button type="button" data-istek-gonder disabled={bekle} onClick={() => gonder(false)}
          className="px-3 py-1.5 rounded bg-violet-600 text-white hover:bg-violet-700 disabled:opacity-60 font-semibold cursor-pointer">
          📨 {soru.cevap_qc ? 'QC’ye yeniden gönder' : 'QC’ye gönder'}
        </button>
      )}
      {aktif && (
        <>
          <span data-istek-durum className="px-2 py-1 rounded bg-violet-50 text-violet-800">
            {istek.durum === 'ISLENIYOR' ? '⚙️ QC işleniyor' : '⏳ QC sırasında'}
            {zaman(istek.tarih) ? ` (${zaman(istek.tarih)})` : ''}
          </span>
          {istek.durum === 'BEKLIYOR' && (
            <>
              <button type="button" data-istek-tetikle disabled={bekle} onClick={() => gonder(false)}
                className="text-violet-700 hover:underline cursor-pointer">yeniden tetikle</button>
              <button type="button" data-istek-iptal disabled={bekle} onClick={() => gonder(true)}
                className="text-gray-500 hover:underline cursor-pointer">iptal</button>
            </>
          )}
        </>
      )}
      {mesaj && <span data-istek-mesaj className="text-gray-600">{mesaj}</span>}
      {hata && <span data-istek-hata className="text-red-700">{hata}</span>}
    </div>
  );
}
